var _defs, _path, _path2, _path3, _path4, _path5, _path6, _polygon, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGmgLogoSRgb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 283.47 101.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#512000;}.cls-2{fill:#e5004a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,50.62a6,6,0,0,0,6.18-6.26A6,6,0,0,0,30,38.11a6,6,0,0,0-6.17,6.25A6,6,0,0,0,30,50.62ZM10.75,79.33a42.1,42.1,0,0,0,14.76,2.89c4.35,0,9.15-.93,9.15-6,0-5.45-5.72-6.72-11.89-6.72-3.55,0-7,.46-10.53.8l1.95-4.16C5.15,61.62,0,54,0,43.09,0,31.86,8.35,17.62,27.57,17.62a32.85,32.85,0,0,1,11.67,1.85l18.19-3.7L52.05,26.3a22.69,22.69,0,0,1,6.64,16.44c0,8.69-3.55,14.59-10.3,19.11A18.89,18.89,0,0,1,58.46,79.1c0,14.7-13.27,22.81-33.06,22.81A71.44,71.44,0,0,1,.8,97.62l10-18.29Z",
    transform: "translate(0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130.62,80.5V42.67c0-2.56-1.4-4.42-4.65-4.42A4.57,4.57,0,0,0,121.19,43V78.64L98.62,80.5V42.9c0-2.79-1.75-4.65-5-4.65-2.68,0-4.43,1.74-4.43,4.77V78.64L66.61,80.5v-61l20.71-1.86v9.54h.24c4.42-5.94,9.89-9.54,17.69-9.54,6.4,0,10.59,2,14.2,6.16a18.76,18.76,0,0,1,13.73-6.16c12.46,0,20,9.19,20,21.3V78.64L130.62,80.5Z",
    transform: "translate(0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.22,50.66a6,6,0,0,0,6.25-6.26,6.26,6.26,0,0,0-12.51,0,6,6,0,0,0,6.26,6.26ZM171.76,79.38a42.79,42.79,0,0,0,14.94,2.9c4.4,0,9.26-.93,9.26-6,0-5.45-5.78-6.72-12-6.72-3.58,0-7.06.46-10.66.81l2-4.17c-9.15-4.52-14.35-12.16-14.35-23.05,0-11.23,8.45-25.1,27.91-25.48a41,41,0,0,1,11.86,1.23,28.43,28.43,0,0,1,12.92,7.45,25.4,25.4,0,0,1,6.72,16.46c0,8.68-3.59,14.59-10.42,19.1a18.87,18.87,0,0,1,10.19,17.26c0,14.71-13.44,22.82-33.48,22.82a73.13,73.13,0,0,1-24.9-4.29l10.08-18.3Z",
    transform: "translate(0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M215.92,24.6l5.72-11.31L203.25,17a28.24,28.24,0,0,1,12.44,7.32l.24.25Z",
    transform: "translate(0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M237.63,18.25A7.57,7.57,0,0,1,232.74,20a7,7,0,0,1-7-7.27,7.11,7.11,0,0,1,7.33-7,8.55,8.55,0,0,1,4.67,1.6l-1,1.28A5.61,5.61,0,0,0,233,7.28a5.47,5.47,0,0,0-5.67,5.62,5.42,5.42,0,0,0,5.32,5.51,6.4,6.4,0,0,0,4-1.38l1,1.22Z",
    transform: "translate(0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M240.75,12.84a5.41,5.41,0,1,0,5.41-5.56,5.54,5.54,0,0,0-5.41,5.56Zm12.38,0a7,7,0,1,1-7-7.14,7.12,7.12,0,0,1,7,7.14Z",
    transform: "translate(0)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "257.51 19.66 255.93 19.98 255.93 0.33 257.51 0 257.51 19.66 257.51 19.66"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M261.88,12.84a5.41,5.41,0,1,0,5.4-5.56,5.54,5.54,0,0,0-5.4,5.56Zm12.38,0a7,7,0,1,1-7-7.14,7.13,7.13,0,0,1,7,7.14Z",
    transform: "translate(0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.36,8.74h.06c1-2.33,2.52-3,5.05-3l-.68,1.6a6,6,0,0,0-.63,0c-1.71,0-3.8,2.11-3.8,5.54v6.84l-1.57.32V6l1.57-.33v3Z",
    transform: "translate(0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmgLogoSRgb);
export default __webpack_public_path__ + "static/media/GMG-Logo-sRGB.e8e2573c0274db6084ef98ad5696ee2f.svg";
export { ForwardRef as ReactComponent };